import React from 'react';
import { useState, useEffect } from "react";
import apiAdm from '../../../services/apiAdm';
import { FiSave, FiXCircle } from "react-icons/fi";
import { SweetAlertSuccess, SweetAlertError } from '../../../components/sweetAlert/swetAlert.jsx';
import { useNavigate } from "react-router-dom";

function CrudEmpresa() {
    const navigate = useNavigate();

    const [fantasia, setFantasia] = useState('');
    const [razao, setRazao] = useState('');
    const [cnpj, setCnpj] = useState('');
    const [inscEst, setInscEst] = useState('');
    const [cep, setCep] = useState('');
    const [uf, setUF] = useState('');
    const [cidade, setCidade] = useState('');
    const [endereco, setEndereco] = useState('');
    const [numero, setNumero] = useState('');
    const [complemento, setComplemento] = useState('');
    const [bairro, setBairro] = useState('');
    const [email, setEmail] = useState('');
    const [fone, setFone] = useState('');
    const [numeroNfe, setNumeroNfe] = useState('');
    const [simplesNacional, setSimplesNacional] = useState('S');

    useEffect(() => {
        getEmpresa();

    }, []);

    function getEmpresa() {
        apiAdm.get('/entidade/' + localStorage.getItem('idEmpresa'))
            .then((resp) => {
                console.log(resp.data.data);
                setFantasia(resp.data.data.nome);
                setRazao(resp.data.data.razao);
                setCnpj(resp.data.data.cnpj);
                setInscEst(resp.data.data.ie);
                setCep(resp.data.data.cep);
                setUF(resp.data.data.uf);
                setCidade(resp.data.data.cidade);
                setEndereco(resp.data.data.endereco);
                setNumero(resp.data.data.enderecoNumero);
                setComplemento(resp.data.data.complemento);
                setBairro(resp.data.data.bairro);
                setEmail(resp.data.data.email);
                setFone(resp.data.data.fone);
            })
            .catch((erro) => {
                alert('Erro ao ler os dados da empresa. ' + erro);
            })
    };

    function ChangeOptante(e){
        alert(e.target.value);
        setSimplesNacional(e.target.value);
    };
  
    function Cancelar() {
        window.history.back();
    };

    function Salvar() {
        let json = {
            nome: fantasia,
            razao: razao,
            ie: inscEst,
            uf: uf,
            cidade: cidade,
            endereco: endereco,
            enderecoNumero: numero,
            complemento: complemento,
            bairro: bairro,
            email: email,
            fone: fone
        };
        SweetAlertSuccess({ texto: 'Registro salvo com sucesso. Devido as alterações no cadastro, é necessário fazer o login novamente.' });
        navigate("/");

        //     apiAdm.post('/entidade/' + localStorage.getItem('idEmpresa'), json )
        //     .then((resp) => {
        //         SweetAlertSuccess({texto:'Registro salvo com sucesso.'});
        //         window. history. back();    
        //     })
        //    .catch((erro) => {
        //         console.log('Erro empresa: ' + erro);
        //         SweetAlertError({texto:'Erro ao salvar os dados da empresa.'})
        //    });

    };

    return <>
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0"></div>
                <div className="row">
                    <div className="col-md-10 py-3">
                        <div className="card">
                            <div className="card-body">
                                <h5 className="text-muted mb-3">Dados da empresa</h5>

                                <div className="panel-container show">
                                    <div className="panel-content">
                                        <div className="row mb-3">
                                            <div className="form-group col-sm-12">
                                                <label for="fantasia" className="form-label">Nome Fantasia</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setFantasia(e.target.value)} value={fantasia} />
                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="form-group col-sm-12">
                                                <label for="razao" className="form-label">Razão Social</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setRazao(e.target.value)} value={razao} />

                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="form-group col-sm-6">
                                                <label for="cnpj" className="form-label">CNPJ</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setCnpj(e.target.value)} value={cnpj} />


                                            </div>
                                            <div className="form-group col-sm-6">
                                                <label for="inscEst" className="form-label">Inscrição Estadual</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setInscEst(e.target.value)} value={inscEst} />

                                            </div>
                                        </div>
                                        <div className="row mb-3">
                                            <div className="form-group col-sm-3">
                                                <label for="cep" className="form-label">Cep</label>
                                                <input type="text"  disabled className="form-control" onChange={(e) => setCep(e.target.value)} value={cep} />

                                            </div>

                                            <div className="form-group col-sm-3">
                                                <label for="uf" className="form-label">Estado</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setUF(e.target.value)} value={uf} />

                                            </div>
                                            <div className="form-group col-sm-6">
                                                <label for="cidade" className="form-label">Cidade</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setCidade(e.target.value)} value={cidade} />

                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="form-group col-sm-8">
                                                <label for="endereco" className="form-label">Endereço</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setEndereco(e.target.value)} value={endereco} />

                                            </div>
                                            <div className="form-group col-sm-4">
                                                <label for="numero" className="form-label">Número</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setNumero(e.target.value)} value={numero} />

                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="form-group col-sm-6">
                                                <label for="complemento" className="form-label">Complemento</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setComplemento(e.target.value)} value={complemento} />
                                            </div>
                                            <div className="form-group col-sm-6">
                                                <label for="bairro" className="form-label">Bairro</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setBairro(e.target.value)} value={bairro} />

                                            </div>
                                        </div>

                                        <div className="row mb-3">
                                            <div className="form-group col-sm-6">
                                                <label for="email" className="form-label">e-mail</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setEmail(e.target.value)} value={email} />
                                                <span className="help-block">E-mail que será exibido na Nota Fiscal</span>
                                            </div>


                                            <div className="form-group col-sm-4">
                                                <label for="fone" className="form-label">Telefone/Celular</label>
                                                <input type="text" disabled className="form-control" onChange={(e) => setFone(e.target.value)} value={fone} />
                                            </div>
                                        </div>

                                    </div>
                                </div>

                                <div className="row mb-3">
                                    <div className="form-group col-sm-6">
                                        <label className="form-label">Logomarca</label>
                                        <div className="custom-file">
                                            <input type="file" className="custom-file-input"
                                                accept="image/png, image/gif, image/jpeg" id="customFile" />
                                        </div>
                                    </div>
                                    <div className="form-group col-sm-3">
                                        <label for="selectOptante" className="form-label">Optante do Simples Nacional?</label>
                                        <select className="form-select" disabled name="optanteSN" onChange={ChangeOptante}>
                                            <option value="S">Sim</option>
                                            <option value="N">Não</option>

                                        </select>
                                    </div>


                                    <div className="form-group col-sm-3">
                                        <label for="numeroNfe" className="form-label">Nro da NF-e ( início )</label>
                                        <input type="text" disabled className="form-control" onChange={(e) => setNumeroNfe(e.target.value)} value={numeroNfe} />
                                    </div>

                                </div>

                            </div>

                        </div>
                        <br></br>
                        <div div className="row mb-3">
                            <div className="btn-opcoes col-md-12" style={{ textAlign: 'right' }}>

                                <button type="button" style={{ margin: 15 }} className="btn btn-outline-secondary float-right"
                                    onClick={() => Cancelar()}>
                                    <FiXCircle /><span> Cancelar </span>
                                </button>
                                {/* <button type="button" className="btn btn-primary "
                                    onClick={() => Salvar()}>
                                    <FiSave /><span> Salvar </span>
                                </button> */}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>

    </>
};

export default CrudEmpresa;